import { UISref } from "@uirouter/react";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../../../../../components/button";
import { KycIcon } from "../../../../../../components/icons/status";
import { columnFlex } from "../../../../../../components/layout";
import { countries } from "../../../../../../store/common/models";
import { useDueDiligenceKycType } from "../../../../../../store/verification/models/internal";
import { FraudRoutes } from "../../../../../kyc-kyb-aml/routes";
import { isCompanyNode, isKycNode, Node } from "./common";

const Value = styled.div`
  text-transform: uppercase;
  font-size: 1.2em;
`;

const Label = styled.div`
  color: #888;
  text-transform: uppercase;
  font-weight: 500;
`;

const Type = styled.div`
  text-align: center;
  margin: 0.5em auto 2em;
  padding: 0 0 1em;
  border-bottom: 1px solid #ddd;
`;

const TypeLabel = styled.div`
  display: block;
  background: #333;
  padding: 0.5em 1em;
  color: white;
  font-weight: 500;
  text-transform: uppercase;
  border-radius: 5px;
  &:not(:last-child) {
    margin-bottom: 0.5em;
  }
`;

const Wrapper = styled.div`
  ${columnFlex};
  justify-content: space-between;
  height: 100%;
`;

export const Tooltip: FunctionComponent<{ node: Node }> = ({ node }) => {
  const dueDiligenceKycTypes = useDueDiligenceKycType();

  if (isKycNode(node)) {
    const { types, fraudCheckId, id, status } = node;
    return (
      <Wrapper>
        <div>
          <Type>
            {types.map((t, key) => (
              <TypeLabel key={key}>{dueDiligenceKycTypes.enum[t]}</TypeLabel>
            ))}
          </Type>
          <Label>Name</Label>
          <Value>{id}</Value>
          <br />
          <Label>Status</Label>
          <Value>{KycIcon(status, "kyc", false)}</Value>
        </div>
        <UISref
          to={FraudRoutes.names.singleIndividualKyc}
          params={{ fraudCheckId }}
        >
          <a>
            <PrimaryButton fullWidth>View KYC</PrimaryButton>
          </a>
        </UISref>
      </Wrapper>
    );
  } else if (isCompanyNode(node)) {
    const { companyRegCountry, companyRegNumber, id } = node;
    return (
      <Wrapper>
        <div>
          <Type>
            <TypeLabel>{id}</TypeLabel>
          </Type>
          <Label>Country</Label>
          <Value>{countries.enum[companyRegCountry]}</Value>
          <br />
          <Label>Reg Number</Label>
          <Value>{companyRegNumber}</Value>
        </div>
      </Wrapper>
    );
  } else {
    const { id } = node;
    return (
      <Wrapper>
        <div>
          <Type>
            <TypeLabel>PENDING</TypeLabel>
          </Type>
          <Label>Name</Label>
          <Value>{id}</Value>
        </div>
      </Wrapper>
    );
  }
};
